import { useCallback, useEffect, useState, createRef, useRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import dummy from './dummy.svg'
import { VscTarget } from 'react-icons/vsc'

const GridItem = ({
  tenant,
  colorMode,
  name,
  canton,
  height1960,
  height1990,
  height2023,
  difference,
  percentage,
  link,
  index,
}: {
  tenant?: object
  colorMode?: string
  name: string
  canton: string
  height1960: number
  height1990: number
  height2023: number
  difference: string
  percentage: string
  link: string
  index: number
}) => {
  const [isMobile, setIsMobile] = useState(false)
  let bottomOffset1990 = 0
  let bottomOffset2023 = 0

  // calculate height of triangle
  const heightRange = 1 - 0.75
  const heightsArr = [height1960, height1990, height2023]
  const diff1990 = height1960 - height1990
  const diff2023 = height1960 - height2023
  const diffTotal = Math.max(...heightsArr) - Math.min(...heightsArr)
  const quotHeight1990 = diff1990 / diffTotal
  const quotHeight2023 = diff2023 / diffTotal
  const relHeight1990 = 1 - heightRange * quotHeight1990
  const relHeight2023 = 1 - heightRange * quotHeight2023
  bottomOffset1990 = 76.5 * relHeight1990 // the 1960-triangle is 76.5% of the SVGs height
  bottomOffset2023 = 86.5 * relHeight2023 // the 1960-triangle is 76.5% of the SVGs height

  /*
  console.log(name)
  console.log('heightsArr', heightsArr)
  console.log('heightsArr', heightsArr)
  console.log('diffTotal', diffTotal)
  console.log('quotHeight1990', quotHeight1990)
  console.log('relHeight1990', relHeight1990)
  console.log('relHeight2023', relHeight2023)
  console.log('bottomOffset1990', bottomOffset1990)
  console.log('bottomOffset2023', bottomOffset2023)
  */

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  const commatize = (word: any) => {
    const replaced = word.toString().replace('.', ',')
    return replaced.indexOf(',0') > 1 && replaced.slice(-2) === ','
      ? replaced.replace(',0', '')
      : replaced
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Griditem className={isMobile ? 'mobile' : 'desktop'}>
      <h4 lang='de'>
        <span className='canton'>
          {' '}
          <img src={require('./images/' + canton + '.svg')} alt={canton} />
        </span>
        <span
          dangerouslySetInnerHTML={{
            __html: name,
          }}
        />{' '}
      </h4>
      <div className='info'>
        <div className='difference'>{difference} Meter</div>
        {/* <div className='percentage'>{percentage}%</div> */}
      </div>
      <div className='graphic'>
        {/*
        <img src={dummy} alt='graphic' />
        */}

        <StyledSVG
          height1990={relHeight1990}
          height2023={relHeight2023}
          viewBox='0 0 134 62'
          preserveAspectRatio='none'
        >
          <g id='mount-1960'>
            <polygon
              className='st0'
              points='-0.0706,61.7562 64.9689,61.7562 31.8029,14.4876 	'
            />
            <polygon
              className='st1'
              points='41.3455,28.0897 34.5741,22.8928 31.5251,28.0897 28.6131,22.8928 22.4305,28.0897 31.8018,14.488 	
		'
            />
            <polygon
              className='st2'
              points='31.5251,61.8694 31.8018,14.488 -0.0717,61.8694 	'
            />
          </g>
          <g id='mount-1990'>
            <polygon
              className='st3'
              points='34.5752,61.7562 99.6147,61.7562 66.4488,14.4876 	'
            />
            <polygon
              className='st1'
              points='75.9922,28.0594 69.2208,22.8753 66.1718,28.0594 63.2598,22.8753 57.0773,28.0594 66.4485,14.491 	
		'
            />
            <polygon
              className='st2'
              points='66.1718,61.7562 66.4485,14.491 34.575,61.7562 	'
            />
          </g>
          <g id='mount-2023'>
            <g>
              <polygon
                className='st4'
                points='69.2211,61.7562 134.2606,61.7562 101.0946,14.4928 		'
              />
            </g>
            <polygon
              className='st1'
              points='110.638,28.0594 103.8667,22.8753 100.8176,28.0594 97.9057,22.8753 91.7231,28.0594 101.0944,14.491 
			'
            />
            <polygon
              className='st2'
              points='100.8176,61.7562 101.0944,14.491 69.2209,61.7562 	'
            />
          </g>
        </StyledSVG>
        <Labels
          height1990={relHeight1990}
          height2023={relHeight2023}
          bottomoffset1990={bottomOffset1990}
          bottomoffset2023={bottomOffset2023}
        >
          <div className='yearlabel year-1960'>1960</div>
          <div className='yearlabel year-1990'>1990</div>
          <div className='yearlabel year-2023'>2023</div>

          <div className='heightlabel height-1960'>{height1960 + ' m'}</div>
          <div className='heightlabel height-1990'>{height1990 + ' m'}</div>
          <div className='heightlabel height-2023'>{height2023 + ' m'}</div>
        </Labels>
      </div>
      <div className='maplink'>
        <a href={link} target='_blank' rel='noreferrer'>
          <VscTarget /> Karte
        </a>
      </div>
    </Griditem>
  )
}
const Griditem = styled.div`
  color: var(--text-color);

  h4 {
    position: relative;
    font-size: 1.75rem;
    font-weight: 400;
    line-height: 2rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.4rem;
      line-height: 1.9rem;
    }
    text-align: left;
    padding: 0 0 0.25rem;
    border-bottom: 1px solid var(--gray-4);
    margin: 0 0 0.2rem;

    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    border-bottom: 1px solid #d4d4d4;
    .canton {
      float: right;
      margin-left: 1rem;
      font-size: 1.4rem;
      font-weight: 600;
      text-align: right;
      img {
        width: 1.75rem;
      }
    }
  }
  .info {
    // display: grid;
    // grid-template-columns: 1fr 1fr;
    font-size: 1.5rem;
    line-height: 2.5rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.3rem;
      line-height: 1.9rem;
    }
    margin-bottom: 1.5rem;

    .difference {
      text-align: right;
    }
    .percentage {
      // text-align: right;
    }
  }
  .graphic {
    position: relative;
  }
  .maplink {
    text-align: center;
    a {
      top: -5px;
      position: relative;
      margin: 0 auto;
      text-decoration: none;
      color: var(--text-color);
      font-size: 1.25rem;
      line-height: 2rem;
      letter-spacing: 0.03rem;
      padding: 0.4rem 1rem;
      border-radius: 0.2rem;
      background-color: var(--button-bg);
      color: var(--button-text);
      -webkit-box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.1);
      box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        background-color: var(--hover-bg);
        color: var(--hover-text);
      }
      svg {
        top: 2px;
        position: relative;
      }
    }
  }
`

const StyledSVG = styled.svg<{
  height1990: number
  height2023: number
}>`
  position: relative;
  overflow: visible;
  #mount-1990 {
    transform: scale(1, ${(prop) => prop.height1990});
    transform-origin: 0 100%;
  }
  #mount-2023 {
    transform: scale(1, ${(prop) => prop.height2023});
    transform-origin: 0 100%;
  }
  .st0 {
    fill: #6f7187;
  }
  .st1 {
    fill: #efece0;
  }
  .st2 {
    opacity: 0.1;
    fill: #202346;
  }
  .st3 {
    fill: #9698a8;
  }
  .st4 {
    fill: #c8c8d1;
  }
`

const Labels = styled.div<{
  height1990: number
  height2023: number
  bottomoffset1990: number
  bottomoffset2023: number
}>`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;

  .yearlabel {
    position: absolute;
    font-size: 1rem;
    font-weight: 600;
    color: #222;
    width: 47%;
    line-height: 1.3rem;
    bottom: 22%;
    text-align: center;
  }
  .year-1960 {
    left: 0;
    bottom: calc(76.5% / 3);
  }
  .year-1990 {
    width: 100%;
    bottom: ${(prop) => (prop.height1990 / 3) * 76.5 + '%'};
    left: 0;
  }
  .year-2023 {
    right: 0;
    bottom: ${(prop) => (prop.height2023 / 3) * 76.5 + '%'};
  }

  .heightlabel {
    width: 47%;
    text-align: center;
    position: absolute;
    font-size: 1.2rem;
    color: var(--text-color);
    font-style: italic;
    letter-spacing: -0.03rem;
    line-height: 2.1rem;
    transform: translateY(-15%); // move up/down
  }
  .height-1960 {
    _bottom: 76.5%; // the 1960-triangle is 76.5% of the SVGs height
    left: 0;
  }
  .height-1990 {
    bottom: ${(prop) => prop.height1990 * 76.5 + '%'};
    width: 100%;
    left: 0;
  }
  .height-2023 {
    bottom: ${(prop) => prop.height2023 * 76.5 + '%'};
    right: 0;
  }
`

export default GridItem
